import { Text } from '../../../common/text.constants';

export const ModalText = {
	active: Text.active,
	cancel: Text.cancel,
	inactive: Text.inactive,
};
